export class VMContentItem {
  id: string;
  title: string;
  content: string;
  titleShort: string;
  contentShort: string;
}

